import React, { useEffect } from 'react';
import {useDispatch,useSelector} from 'react-redux';
import TagManager from 'react-gtm-module';
import get from 'lodash/get';

export default function GlobalTagManager() {
  const dispatch = useDispatch();
  const isGlobalDataLayerSet = useSelector(state=> state.CommonReducer.isGlobalDataLayerSet);
  const memberDetails=useSelector(state=> state.CommonReducer.customerProfile);

  useEffect(() => {
    if (isGlobalDataLayerSet) return;

    let applicationType = get(memberDetails, 'applicationType', '');
    if (applicationType === "WOW") {
      applicationType = "weeks";
    }
    let userLocal = get(memberDetails, 'locale', '');
    let userGroupId = '';
    if (userLocal === 'en_US' || userLocal === 'en_CA' || userLocal === 'fr_CA') {
      userGroupId = '20';
    }

    const tagManagerArgs = {
      gtmId: window.weeksWebCloudConfig.REACT_APP_GTM_ID,
      dataLayerName: window.weeksWebCloudConfig.REACT_APP_GTM_DATALAYER_NAME
    };

    TagManager.initialize(tagManagerArgs);
    dispatch({ type: "SET_GLOBAL_DATA_LAYER", payload: true });

    const memberDataArgs = {
      dataLayer: {
        member: {
          brand: "RCI",
          country: get(memberDetails, 'country', ''),
          expire: get(memberDetails, 'expire', ''),
          gNumber_sbr_id: get(memberDetails, 'subscriberId', '').slice(0, 4) + '-' + get(memberDetails, 'subscriberId', '').slice(4, get(memberDetails, 'subscriberId', '').length),
          groupId: userGroupId,
          id_primary_evs: get(memberDetails, 'subscriberId', ''),
          loggedin: "true",
          memberStatus: get(memberDetails, 'tierStatus', ''),
          memberTenure: get(memberDetails, 'memberTenure', ''),
          tier: get(memberDetails, 'enrolledARP', ''),
          type: applicationType,
          weeks_service_office: get(memberDetails, 'weeksOfficeCode', '')
        },
        page: {
          locale: get(memberDetails, 'locale', ''),
        },
      },
    };
    const loginEventArgs = {
      dataLayer: {
        event: "eventTracker",
        eventCat: "navigation",
        eventAct: "sign in",
        eventLbl: "Successful",
        nonInteraction: 0,
        eventCallback: function () {},
        signinCount: 1,
        successFulSearchCount: 0,
        unsuccessFulSearchCount: 0,
        filterCount: 0
      }
    };

    TagManager.dataLayer(memberDataArgs);
    TagManager.dataLayer(loginEventArgs);
  }, [isGlobalDataLayerSet, memberDetails, dispatch]);

  return (
    <></>
  );
}

